import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdminBoxSaleMissingItemPickStrategyProviderService
} from '../providers/admin-box-sale-missing-item-pick-strategy-provider.service';
import { AdminBoxSaleMissingItemPickStrategy } from '../enums/admin-box-sale-missing-item-pick-strategy';

@Pipe({
  name: 'boxSaleMissingItemPickStrategy',
})
export class AdminBoxSaleMissingItemPickStrategyPipe implements PipeTransform {
  private readonly provider = inject(AdminBoxSaleMissingItemPickStrategyProviderService);

  public transform(strategy: AdminBoxSaleMissingItemPickStrategy): Observable<string> {
    return this.provider.labelFor(strategy);
  }
}
